import React, { Component } from 'react';

import { ReactComponent as ContentListEmptyImage } from 'components/svg/icons/content-list-empty-image.svg';
import { ReactComponent as Interrogation } from 'components/svg/icons/interrogation.svg';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

export default class ContentListEmpty extends Component {
  static propTypes = {
    linkFaq: PropTypes.string
  };

  render() {
    const { linkFaq } = this.props;

    return (
      <div className="empty__list">
        <div className="empty__list__image">
          <ContentListEmptyImage />
        </div>
        <div className="empty__list__description">
          <I18n label="content_list.empty.new_description" />
        </div>
        {linkFaq && (
          <div className="empty__list__help">
            <span className="empty__list__help__icon">
              <Interrogation />
            </span>
            <div>
              <a
                href={linkFaq}
                target="_blank"
                rel="noopener noreferrer"
                className="empty__list__help__link"
              >
                <I18n label="content_list.empty.center_help_link" />
              </a>
              &nbsp;
              <I18n
                label="content_list.empty.center_help_complement"
                className="empty__list__help__complement"
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
